import classes from "./index.module.css"
import { toggleIntersectionCheckRangeStartField, toggleIntersectionCheckRangeEndField } from "@store/timetable/timetableSlice"
import { useDispatch, useSelector } from "react-redux"
import { DatePicker } from 'antd';
import dayjs from 'dayjs'

export const Range = () => {
    const dispatch = useDispatch();
    const range = useSelector(state => state.timetable.intersectionCheck.range);
    const onChangeStart = (date, dateString) => {
        const value = dateString.length < 3 ? null : dateString
        dispatch(toggleIntersectionCheckRangeStartField(value))
    }
    const onChangeEnd = (date, dateString) => {
        const value = dateString.length < 3 ? null : dateString
        dispatch(toggleIntersectionCheckRangeEndField(value))
    }

    return (
        <div className={classes.wrapperInputs}>
            <DatePicker 
                value={range.start ? dayjs(range.start, 'YYYY-MM-DD') : null}
                className={classes.antd}
                placeholder="Выб. дату начала"
                onChange={onChangeStart} />
            <DatePicker 
                value={range.end ? dayjs(range.end, 'YYYY-MM-DD') : null}
                className={classes.antd}
                placeholder="Выб. дату конца"
                onChange={onChangeEnd} />
        </div>
    )
}
